type IdentifyFn<TData> = (userId: string, data: TData, userHash: string) => unknown

/**
 * Identifies the user in Gleap only once the identity-verification hash is known.
 *
 * The Gleap project enforces identity verification: an identify without a valid
 * hash is answered 401, and `Gleap.identify` returns a promise that rejects.
 * Returns whether identify was called.
 */
export function identifyWhenVerified<TData>(
	identify: IdentifyFn<TData>,
	userId: string,
	data: TData,
	userHash: string | undefined,
	onRefused: () => void,
): boolean {
	if (!userHash) {
		return false
	}
	Promise.resolve()
		.then(() => identify(userId, data, userHash))
		.catch(onRefused)
	return true
}
